import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const ModalAlert = ({ open, onClose, message }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 200,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        textAlign: 'center'
      }}>
        <Typography id="modal-description" sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Button onClick={onClose} sx={{ mt: 2 }}>
          확인
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalAlert;
